<template>
  <div>
    <ButtonBack class="mb_m"/>
    <div class="input">
      <div class="input-label">セット名</div>
      <div class="input-group">
        <input type="text" class="input-text" v-model="name">
      </div>
    </div>

    <div>
      <div class="input mb_m">
        <div class="input-label">マップ</div>
        <div class="input-group">
          <label for="map" class="input-map">
            {{ fileName || 'ファイルを選択してください' }}
            <input
              type="file"
              class="input-file"
              id="map"
              name="map"
              style="display:none;"
              accept="image/png,image/jpeg,application/pdf"
              @change="change">
          </label>
        </div>
      </div>

      <file-preview :file="file" :fileType="fileType" />

    </div>

    <slot></slot>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import FilePreview from '@/components/Quizset/FilePreview'

export default {
  components: {
    ButtonBack,
    FilePreview
  },

  data () {
    return {
      file: '',
      fileType: '',
      fileName: ''
    }
  },

  destroyed: function () {
    this.$store.commit('quizset/setMap')
  },

  computed: {
    name: {
      get: function () {
        return this.$store.state.quizset.name
      },
      set: function (value) {
        this.$store.commit(
          'quizset/setName',
          value
        )
      }
    }
  },

  methods: {
    change: function (event) {
      let fr = new FileReader()
      fr.onload = () => {
        this.file = fr.result
        this.$store.commit(
          'quizset/setMap',
          fr.result
        )
        this.$store.commit(
          'quizset/setMapChanged',
          true
        )
      }

      const file = event.target.files[0]
      this.fileName = file.name
      this.fileType = file.type
      fr.readAsDataURL(file)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';

.input-map {
  @include input-file;
  width: 100%;
}
</style>
